import { FC } from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import theme from 'theme'

/* Components */
import { Wrapper } from './detailsCard.styles'
import { SSMCardSkeleton, SSMCardSkeletonWrapper } from '../../../../security-stack-map/components/ssmCard.styles'

interface Props {
  icon: JSX.Element
  text: string
  value: number
  handleClick: (text: string) => void
  isLoading?: boolean
}

const DetailsCard: FC<Props> = ({ icon, handleClick, text, value, isLoading }) => (
  <Wrapper onClick={() => handleClick(text)} isloading={isLoading ? 'true' : 'false'}>
    {isLoading ? (
      <SSMCardSkeletonWrapper
        className="card-skeleton-wrapper"
        sx={{
          width: '90% !important',
          margin: '0 auto !important'
        }}
      >
        <SSMCardSkeleton className="card-skeleton">
          <Skeleton
            variant="rectangular"
            component="div"
            animation="wave"
            width="100%"
            height="54px"
            className="card-skeleton-inner"
            sx={{ borderRadius: theme.attributes.borderRadius.tertiary }}
          />
        </SSMCardSkeleton>
      </SSMCardSkeletonWrapper>
    ) : (
      <>
        <Box className="details-card-header">
          {icon}
          <Typography>{value}</Typography>
        </Box>
        <Box className="details-card-content">
          <Typography>{text}</Typography>
        </Box>
      </>
    )}
  </Wrapper>
)

export default DetailsCard
